import { findComponentById } from "./component";
import { StoryStatus } from "../enums";
import StyleguideData from "../model/StyleguideData";

function calculateStoryStatus(connectedComponentIds: string[], styleguidesData: StyleguideData[]) {
    const missingComponentCount = connectedComponentIds.filter(
        connectedComponentId => !findComponentById(styleguidesData, connectedComponentId)
    ).length;
    let status: StoryStatus = StoryStatus.Unlinked;

    if (connectedComponentIds.length) {
        status = StoryStatus.Linked;
    }

    if (missingComponentCount) {
        status = StoryStatus.HasIssue;
    }

    return status;
}

export { calculateStoryStatus };
